// extracted by mini-css-extract-plugin
export default {"input-group":"styles-scoped__input-group--qNAC5","inputGroup":"styles-scoped__input-group--qNAC5","withAsterisk":"styles-scoped__withAsterisk--P8clj"};